module.exports = __webpack_public_path__ + "img/live-bar-top.bc5ea1d8.svg";